// eslint-disable-next-line eqeqeq
export const castBoolean = (value) => value == 'true'
